import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { ENVIRONMENT_CONFIG, EnvironmentConfiguration } from "src/environments/model/environment.model";
import { EngineeringData } from "./api/engineering-data";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root', // Singleton
})
export class EngineeringToolsApiService {
  constructor(
    private readonly _http: HttpClient,
    @Inject(ENVIRONMENT_CONFIG) public environment: EnvironmentConfiguration,
  ) { }

  public Get<T>(url: string, paramsObject: any): Observable<T> {
      return this._http.get<T>(this.environment.engineeringToolsEndpoint + url, {
        // headers: {
        //   Email: this.Email,
        //   FullName: this.FullName,
        //   GeaIdUserId: this.GeaIdUserId,
        //   AuthToken: this.AuthToken,
        // },
        params: paramsObject,
      });
  }

  public Post(
    url: string,
    paramsObject: any
  ): Observable<any> {
    let formData: FormData = new FormData();
    for (let param in paramsObject) {
      formData.append(param, paramsObject[param]);
    }
    return this._http.post<string>(this.environment.engineeringToolsEndpoint + url, formData, {
      headers: {
      },
    });
  }

  public CreateComponent(type: string = "") {
    return this.Post("UpdateComponent", { "CreateType": type });
  }

  public UpdateComponent(type: string = "", state: any) {
    return this.Post("UpdateComponent", { "CreateType": type, "State": JSON.stringify(state) });
  }

  public SaveComponent(userId: number, type: string = "", state: any, name: string = "", projectNumber: string = "", comments: string = "", id: number = 0) {
    return this.Post("SaveComponent", { "UserId": userId, "Type": type, "State": JSON.stringify(state), "Name": name, "ProjectNumber": projectNumber, "Comments": comments, "Id": id });
  }

  public GetComponentSaves(userId: number, type: string = "", projectNumber: string = "") {
    return this.Post("GetComponentSaves", { "UserId": userId, "Type": type, "ProjectNumber": projectNumber });
  }

  public GetAllProjectComponentSaves(projectNumber: string = "") {
    return this.Post("GetAllProjectComponentSaves", { "ProjectNumber": projectNumber });
  }

  public LoadComponent(id: number) {
    return this.Post("LoadComponent", { "Id": id });
  }

  public ExportDebugData(type: string = "", state: any) : Observable<string> {
    return this.Post("ExportDebugData", { "CreateType": type, "State": JSON.stringify(state) });
  }

  public CreateDefaultProjectCalculations(projectNumber: string) {
    return this.Post("CreateDefaultProjectCalculations", { "ProjectNumber": projectNumber });
  }
  
}
  